import React from 'react'
import type { ICellRendererParams } from 'ag-grid-community'
import { Avatar } from 'antd'

export function BuyerCellRenderer({ value }: ICellRendererParams) {
  if (!value) return null

  // Get initials from the buyer name
  const getInitials = (name: string) => {
    const words = name.split(' ')
    if (words.length >= 2) {
      return words[0][0] + words[1][0]
    }
    return name.substring(0, 2).toUpperCase()
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <Avatar size={24} style={{ backgroundColor: '#1890ff' }}>
        {getInitials(value)}
      </Avatar>
    </div>
  )
}
